"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var QuotesModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotesModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
const QuoteTabForm_1 = require("./_partials/QuoteTabForm");
/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let QuotesModuleForm = QuotesModuleForm_1 = class QuotesModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.icons = backoffice_1.DashmixIconName;
        this.newTab = {
            label: '',
            intro: null,
            text: null,
            quote: { text: '', author: { image: null, name: '', role: '' } }
        };
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = QuotesModuleForm_1.getInitialContent();
    }
    /**
     * Vue lifecycle hook.
     */
    mounted() {
        this.$nextTick(() => {
            if (this._content.tabs.length === 0) {
                this.addNewItem();
            }
            this.findImagesRelated();
        });
    }
    /**
     * Function to add new stat item to content
     */
    addNewItem() {
        this._content.tabs = [...this._content.tabs, { ...JSON.parse(JSON.stringify(this.newTab)) }];
    }
    /**
     * Function to delete stat
     *
     * @param index of item to delete
     */
    deleteTab(index) {
        const tabCopy = [...this._content.tabs];
        tabCopy.splice(index, 1);
        this._content.tabs = tabCopy;
    }
    /**
     * Function to find image source
     */
    findImageSource(index) {
        this.pickRelated(services_1.Picker.Media, (related) => this.setImageSource(index, related));
    }
    /**
     * Function to get author image thumbnail form related descriptions
     *
     * @return string
     */
    getThumbnail(tab) {
        return tab.quote.author.image ? this.description(tab.quote.author.image) : '';
    }
    /**
     * Function to remove author image
     */
    removeImage(index) {
        this._content.tabs[index].quote.author.image = null;
    }
    /**
     * Function to find image related
     */
    findImagesRelated(related) {
        if (related) {
            this.describe(related, 'url');
            return;
        }
        for (const tab of this._content.tabs) {
            if (tab.quote.author.image && typeof !tab.quote.author.image !== 'undefined') {
                this.describe(tab.quote.author.image, 'url');
            }
        }
    }
    /**
     * Function to set author image source
     */
    setImageSource(index, source) {
        this._content.tabs[index].quote.author.image = source;
        this.$nextTick(() => {
            this.findImagesRelated(source);
        });
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.Quotes,
            // TODO - determine component size
            size: {
                colSpan: 6,
                rowSpan: 1,
                isResizable: false,
                maxColSpan: 6,
                minColSpan: 6,
                minRowSpan: 1,
                maxRowSpan: 1
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            background: null,
            tabs: []
        };
    }
};
QuotesModuleForm = QuotesModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'QuotesModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixInput: backoffice_1.DashmixInput,
            FormErrors: form_2.FormErrors,
            QuoteTabForm: QuoteTabForm_1.QuoteTabForm
        },
        template: `
    <div>
      <!-- Background -->
      <div class="form-group">
        <label for="background" class="d-block">{{ $t('forms.shared.background.label') }}</label>
        <DashmixInput :model.sync="_content.background" name="background"
                      :placeholder="$t('forms.shared.background.placeholder')" />
      </div>
      <!-- Background | END -->

      <label for="tabs" class="d-block">{{ $t('forms.quotes.tabs.label') }}</label>
      <QuoteTabForm v-for="(tab, index) in this._content.tabs"
                    :quoteData.sync="tab"
                    :imageThumbnail="getThumbnail(tab)"
                    :disabled="disabled"
                    @delete="() => deleteTab(index)" @deleteImage="() => removeImage(index)"
                    @selectImage="() => findImageSource(index)" />

      <DashmixButton :icon="icons.PlusSolid" variant="icon"
                     :label="$t('forms.quotes.addNew')" @click="addNewItem" />

      <!-- Form errors -->
      <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
    </div>
  `
    })
], QuotesModuleForm);
exports.QuotesModuleForm = QuotesModuleForm;
//# sourceMappingURL=Quotes.form.js.map